// DS: MO2.4 Core Sale Branded Button
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { useCurrentPromo } from '../../utils/hooks/useCurrentPromo';
import noop from '../../utils/noop';
import s from './BuyCoreButton.scss';
const BuyCoreButton = (_param)=>{
    var { promo, className, biData, referer, size, onClick = noop, children } = _param, props = _object_without_properties(_param, [
        "promo",
        "className",
        "biData",
        "referer",
        "size",
        "onClick",
        "children"
    ]);
    const { t } = useTranslation();
    const currentPromo = useCurrentPromo('self') || promo;
    return /*#__PURE__*/ React.createElement(BrandedButton, _object_spread_props(_object_spread({}, props), {
        size: size,
        className: c(className, s[`root-${size}`]),
        variant: "core-orange",
        href: Url.coreMembershipLink(referer),
        target: "_blank",
        onClick: onClick,
        biData: _object_spread_props(_object_spread({}, biData), {
            evid: BiEventType.BUY_CORE_BUTTON
        })
    }), currentPromo ? /*#__PURE__*/ React.createElement(React.Fragment, null, children, /*#__PURE__*/ React.createElement("span", {
        className: s['sale']
    }, t('buyCoreButton.sale', {
        sale: currentPromo.discountValuePercent
    }), /*#__PURE__*/ React.createElement("svg", {
        className: s['star-one'],
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M6.80612 0.00195312L8.64439 4.9698L13.6122 6.80807L8.64439 8.64634L6.80612 13.6142L4.96785 8.64634L0 6.80807L4.96785 4.9698L6.80612 0.00195312Z",
        fill: "white"
    })), /*#__PURE__*/ React.createElement("svg", {
        className: s['star-two'],
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M6.80612 0.00195312L8.64439 4.9698L13.6122 6.80807L8.64439 8.64634L6.80612 13.6142L4.96785 8.64634L0 6.80807L4.96785 4.9698L6.80612 0.00195312Z",
        fill: "white"
    })), /*#__PURE__*/ React.createElement("svg", {
        className: s['star-three'],
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M6.80612 0.00195312L8.64439 4.9698L13.6122 6.80807L8.64439 8.64634L6.80612 13.6142L4.96785 8.64634L0 6.80807L4.96785 4.9698L6.80612 0.00195312Z",
        fill: "white"
    })))) : children);
};
BuyCoreButton.displayName = 'BuyCoreButton';
export default BuyCoreButton;
